import React from "react";

export default function MonthPicker({ value, onChange,view ,setView,openCreate}) {
    const [open, setOpen] = React.useState(false);
    const btnRef = React.useRef(null);
    const menuRef = React.useRef(null);

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const nowY = new Date().getFullYear();
    const years = Array.from({ length: 11 }, (_, i) => nowY - 5 + i);


    React.useEffect(() => {
        const onDoc = (e) => {
            if (!menuRef.current || !btnRef.current) return;
            if (!menuRef.current.contains(e.target) && !btnRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, []);

    const monthIdx = value.getMonth();
    const year = value.getFullYear();

    return (
        <div className="cal-monthpicker">
            <div className="cal-view-group">
                <button
                    className={`btn ${view === "day" ? "is-primary" : ""}`}
                    onClick={() => setView("day")}
                >
                    Day
                </button>
                <button
                    className={`btn ${view === "week" ? "is-primary" : ""}`}
                    onClick={() => setView("week")}
                >
                    Week
                </button>
                <button
                    className={`btn ${view === "month" ? "is-primary" : ""}`}
                    onClick={() => setView("month")}
                >
                    Month
                </button>
                <button className="btn is-accent" onClick={openCreate}>
                    + Add Schedule
                </button>
            </div>
            <button
                ref={btnRef}
                className="cal-monthpicker__btn"
                onClick={() => setOpen((v) => !v)}
                aria-haspopup="dialog"
                aria-expanded={open}
            >
                <span className="cal-monthpicker__title">
                    {months[monthIdx]} <span className="muted">{year}</span>
                </span>
                <span className={`cal-monthpicker__caret ${open ? "is-open" : ""}`}>▾</span>
            </button>

            {open && (
                <div ref={menuRef} className="cal-monthpicker__menu">
                    <div className="cal-monthpicker__cols">
                        <div className="cal-monthpicker__col">
                            {months.map((m, i) => (
                                <button
                                    key={m}
                                    className={`cal-monthpicker__item ${i === monthIdx ? "is-active" : ""}`}
                                    onClick={() => onChange(new Date(year, i, 1))}
                                >
                                    {m}
                                </button>
                            ))}
                        </div>
                        <div className="cal-monthpicker__col cal-monthpicker__years">
                            {years.map((y) => (
                                <button
                                    key={y}
                                    className={`cal-monthpicker__item ${y === year ? "is-active" : ""}`}
                                    onClick={() => onChange(new Date(y, monthIdx, 1))}
                                >
                                    {y}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
